import BaseApi from '../base/base'
import Question, { ExamResultQuestion, ExamTestQuestion } from '../../models/question'

export default class QuestionApi extends BaseApi {
  constructor() {
    super()
    this.path = ''
  }

  async get(userExamId: number) {
    this.path = `/user_exams/${userExamId}/qs`
    const response = await this.getRequest()
    return response.data.map((element) => {
      return new ExamTestQuestion(element)
    })
  }

  async getIndexResult(userExamId: number) {
    this.path = `/user_exams/${userExamId}/qs/index_result`
    const response = await this.getRequest()
    
    return response.data.map((element) => {
      return new ExamResultQuestion(element)
    })
  }

  async show(userExamId: number, id: number): Promise<Question[]> {
    this.path = `/user_exams/${userExamId}/qs/${id}`
    const response = await this.getRequest()
    return response.data.map((element) => {
      return new Question(element)
    })
  }

  async showResult(userExamId: number, id: number): Promise<Question[]> {
    this.path = `/user_exams/${userExamId}/qs/${id}/show_result`
    const response = await this.getRequest()
    return response.data.map((element) => {
      return new Question(element)
    })
  }
}
